import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.css'
})
export class NavbarComponent {
  isSticky: boolean = false;
  logo: string = 'assets/images/logo.svg';
  isCollapsed: boolean = true;
  logoResponsive: string = 'assets/images/logo-2.svg'; // Ruta al logo para móvil

  constructor(private router: Router) { }

  ngOnInit(): void { }

  scrollToSection(sectionId: string) {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

    if (scrollTop > 100) {
      this.isSticky = true;
      this.logo = 'assets/images/logo.svg';
    } else {
      this.isSticky = false;
      this.logo = 'assets/images/logo.svg';
    }
  }

  navigateTo(route: string) {
    this.router.navigate([route]);
  }

  // Método para cerrar el menú móvil después de seleccionar una opción
  closeMobileMenu() {
    this.isCollapsed = true;
  }

  onDesktopMenu(): void {
    // Lógica para abrir/cerrar menú de escritorio
    console.log('Desktop menu clicked');
  }

  // onShowClick(): void {
  //   // Lógica para mostrar algo (por ejemplo, la bolsa de compras)
  //   console.log('Shopping bag clicked');
  // }
}
